import { defineComponent, ref } from "vue";
import StreamRegion from "../common/StreamRegion/StreamRegionPC.vue.mjs";
import { isPC } from "../../../utils/environment.mjs";
import { StreamPlayQuality } from "../../../services/manager/mediaManager.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "index",
  props: {
    streamInfo: null,
    fillMode: null,
    supportTouchScale: { type: Boolean }
  },
  emits: ["stream-view-dblclick"],
  setup(__props) {
    const aspectRatio = ref(isPC ? "16:9" : "auto");
    return { __sfc: true, aspectRatio, StreamRegion, StreamPlayQuality };
  }
});
export {
  _sfc_main as default
};
